import { render, staticRenderFns } from "./rightXm.vue?vue&type=template&id=c2a4827c&scoped=true&"
import script from "./rightXm.vue?vue&type=script&lang=js&"
export * from "./rightXm.vue?vue&type=script&lang=js&"
import style0 from "./rightXm.vue?vue&type=style&index=0&id=c2a4827c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a4827c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2a4827c')) {
      api.createRecord('c2a4827c', component.options)
    } else {
      api.reload('c2a4827c', component.options)
    }
    module.hot.accept("./rightXm.vue?vue&type=template&id=c2a4827c&scoped=true&", function () {
      api.rerender('c2a4827c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xmy/drawer/rightBar/rightXm.vue"
export default component.exports